import React, { useState } from "react";
import styles from "./BudgetCalculator.module.css";

const BudgetCalculator = ({ onClose }) => {
  const services = [
    { name: "Ring Ceremony", price: 20000 },
    { name: "Pre Wedding", price: 35000 },
    { name: "Bride Side - Haldi, Wedding, Reception (Cinematic Work)", price: 60000 },
    { name: "Groom Side - Haldi, Wedding, Reception (Cinematic Work)", price: 60000 },
    { name: "Traditional Work - Wedding & Reception", price: 35000 },
  ];

  const [selectedServices, setSelectedServices] = useState([]);
  
  const toggleService = (service) => {
    setSelectedServices((prev) =>
      prev.some((s) => s.name === service.name)
        ? prev.filter((s) => s.name !== service.name)
        : [...prev, service]
    );
  };

  const totalBudget = selectedServices.reduce(
    (acc, service) => acc + service.price,
    0
  );

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>Calculate Your Budget</h2>
        <p className={styles.description}>Select the services you need:</p>
        <div className={styles.servicesList}>
          {services.map((service, index) => (
            <div key={index} className={styles.serviceItem}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  className={styles.checkboxInput}
                  checked={selectedServices.some((s) => s.name === service.name)}
                  onChange={() => toggleService(service)}
                />
                <span className={styles.customCheckbox}></span>
                {service.name} - ₹{service.price.toLocaleString()}
              </label>
            </div>
          ))}
        </div>
        <h2 className={styles.totalBudget}>Total Estimated Budget: ₹<span>{totalBudget.toLocaleString()}</span></h2>
        <button className={styles.closeButton} onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default BudgetCalculator;
